import { Controller } from "@hotwired/stimulus"
import { Calendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.calendar = new Calendar(this.element, {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: "dayGridMonth",
      locale: "pt-br",
      headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,dayGridWeek"
      },
      buttonText: {
        today: "Hoje",
        month: "Mês",
        week: "Semana"
      },
      events: {
        url: this.urlValue,
        method: "GET"
      },
      eventClick: (info) => {
        info.jsEvent.preventDefault()
        if (info.event.url) {
          window.Turbo.visit(info.event.url)
        }
      },
      height: "auto",
      dayMaxEvents: 3,
      eventDisplay: "block",
      eventTimeFormat: {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      }
    })

    this.calendar.render()
  }

  disconnect() {
    if (this.calendar) {
      this.calendar.destroy()
    }
  }
}
